<template>
  <b-card class="bg-f7fafe w-full h-270px uploader-border">
    <div
      class="flex justify-center cursor-pointer h-full items-center"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      @click="$refs.imageInput.click()"
    >
      <div class="text-center">
        <div class="flex justify-center mb-2">
          <feather-icon icon="UploadCloudIcon" />
        </div>
        <small class="font-semibold"
          >Drop files to upload or<br />
          <span class="text-primary">browse</span><br/>
          <span class="text-primary">Maximum 10 MB</span></small
        >
      </div>
    </div>
    <div>
      <input
        ref="imageInput"
        @change="handleClick"
        type="file"
        :accept="accept + '/*'"
        class="hidden"
      />
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    onSuccess: {
      type: Function,
      required: true,
    },
    accept: {
      type: String,
      default: "image",
    },
  },
  methods: {
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$vs.notify({
          title: "Warning",
          text: "Only support uploading one file!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        return;
      }
      const rawFile = files[0];
      this.uploadImage(rawFile);
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadImage(rawFile);
    },
    uploadImage(file) {
      this.$refs["imageInput"].value = null; // fix can't select the same image
      this.renderImage(file);
    },
    renderImage(file) {
      this.onSuccess && this.onSuccess(file);
    },
  },
};
</script>

<style scoped>
.bg-f7fafe {
  background-color: #f7fafe;
}
.h-270px {
  height: 270px;
}
</style>
